module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div id=\"changesSection\" class=\"row ")
    ; __append(escapeFn( hasChanges ? '' : 'hide' ))
    ; __append("\">\r\n    <div class=\"col-md-4\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"applyChanges\" value=\"Apply Changes\"/>\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"cancelChanges\" value=\"Cancel\">\r\n    </div>\r\n</div>\r\n<div id=\"actionsSection\" class=\"row ")
    ; __append(escapeFn( hasChanges ? 'hide' : '' ))
    ; __append("\">\r\n    <div class=\"col-md-5\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"newAction\" value=\"New Action\"/>\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"migrate\" value=\"Migrate\">\r\n        <input type=\"button\" class=\"btn btn-default\" name=\"delete\" ")
    ; __append(escapeFn( isOwner ? '' : 'disabled' ))
    ; __append(" value=\"Delete\">\r\n    </div>\r\n</div>")
  }
  return __output;

}